// Re-export from App.jsx for compatibility
import App from './App.jsx';
export default App;
